var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "option-items-pane" },
    [
      _vm.selectedWidget.type === "radio" ||
      (_vm.selectedWidget.type === "select" &&
        !_vm.selectedWidget.options.multiple)
        ? _c(
            "el-radio-group",
            {
              on: { change: _vm.emitDefaultValueChange },
              model: {
                value: _vm.optionModel.defaultValue,
                callback: function ($$v) {
                  _vm.$set(_vm.optionModel, "defaultValue", $$v)
                },
                expression: "optionModel.defaultValue",
              },
            },
            [
              _c(
                "draggable",
                _vm._b(
                  { attrs: { tag: "ul", list: _vm.optionModel.optionItems } },
                  "draggable",
                  {
                    group: "optionsGroup",
                    ghostClass: "ghost",
                    handle: ".drag-option",
                  },
                  false
                ),
                _vm._l(_vm.optionModel.optionItems, function (option, idx) {
                  return _c(
                    "li",
                    { key: idx },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: option.value } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { disabled: "", size: "mini" },
                            model: {
                              value: option.value,
                              callback: function ($$v) {
                                _vm.$set(option, "value", $$v)
                              },
                              expression: "option.value",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { disabled: "", size: "mini" },
                            model: {
                              value:
                                option[
                                  _vm.optionModel.labelName
                                    ? _vm.optionModel.labelName
                                    : "name"
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  option,
                                  _vm.optionModel.labelName
                                    ? _vm.optionModel.labelName
                                    : "name",
                                  $$v
                                )
                              },
                              expression:
                                "option[optionModel.labelName ? optionModel.labelName : 'name']",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm.selectedWidget.type === "select" &&
          _vm.selectedWidget.options.multiple
        ? _c(
            "el-checkbox-group",
            {
              on: { change: _vm.emitDefaultValueChange },
              model: {
                value: _vm.optionModel.defaultValue,
                callback: function ($$v) {
                  _vm.$set(_vm.optionModel, "defaultValue", $$v)
                },
                expression: "optionModel.defaultValue",
              },
            },
            [
              _c(
                "draggable",
                _vm._b(
                  { attrs: { tag: "ul", list: _vm.optionModel.optionItems } },
                  "draggable",
                  {
                    group: "optionsGroup",
                    ghostClass: "ghost",
                    handle: ".drag-option",
                  },
                  false
                ),
                _vm._l(_vm.optionModel.optionItems, function (option, idx) {
                  return _c(
                    "li",
                    { key: idx },
                    [
                      _c(
                        "el-checkbox",
                        { attrs: { label: option.value } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { size: "mini" },
                            model: {
                              value: option.value,
                              callback: function ($$v) {
                                _vm.$set(option, "value", $$v)
                              },
                              expression: "option.value",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { size: "mini" },
                            model: {
                              value: option.label,
                              callback: function ($$v) {
                                _vm.$set(option, "label", $$v)
                              },
                              expression: "option.label",
                            },
                          }),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "iconfont icon-drag drag-option",
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "col-delete-button",
                            attrs: {
                              circle: "",
                              plain: "",
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-minus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteOption(option, idx)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm.selectedWidget.type === "cascader"
        ? _c("el-cascader", {
            staticStyle: { width: "100%" },
            attrs: {
              options: _vm.optionModel.optionItems,
              placeholder: _vm.i18nt("render.hint.selectPlaceholder"),
            },
            on: { change: _vm.emitDefaultValueChange },
            model: {
              value: _vm.optionModel.defaultValue,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "defaultValue", $$v)
              },
              expression: "optionModel.defaultValue",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showImportDialogFlag
        ? _c(
            "el-dialog",
            {
              staticClass: "small-padding-dialog",
              attrs: {
                title: _vm.i18nt("designer.setting.importOptions"),
                visible: _vm.showImportDialogFlag,
                "show-close": true,
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showImportDialogFlag = $event
                },
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: "10" },
                    model: {
                      value: _vm.optionLines,
                      callback: function ($$v) {
                        _vm.optionLines = $$v
                      },
                      expression: "optionLines",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "large", type: "primary" },
                      on: { click: _vm.saveOptions },
                    },
                    [_vm._v(_vm._s(_vm.i18nt("designer.hint.confirm")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "large", type: "" },
                      on: {
                        click: function ($event) {
                          _vm.showImportDialogFlag = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showImportCascaderDialogFlag
        ? _c(
            "el-dialog",
            {
              staticClass: "small-padding-dialog",
              attrs: {
                title: _vm.i18nt("designer.setting.importOptions"),
                visible: _vm.showImportCascaderDialogFlag,
                "show-close": true,
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "destroy-on-close": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showImportCascaderDialogFlag = $event
                },
              },
            },
            [
              _c("code-editor", {
                attrs: { mode: "json", readonly: false },
                model: {
                  value: _vm.cascaderOptions,
                  callback: function ($$v) {
                    _vm.cascaderOptions = $$v
                  },
                  expression: "cascaderOptions",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "large", type: "primary" },
                      on: { click: _vm.saveCascaderOptions },
                    },
                    [_vm._v(_vm._s(_vm.i18nt("designer.hint.confirm")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "large", type: "" },
                      on: {
                        click: function ($event) {
                          _vm.showImportCascaderDialogFlag = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }